import { Link, useLocation } from "react-router-dom";
import Seo from "../components/Seo";
import "../style/style-pages/legal-page.css";

const NoPage = () => {
    const location = useLocation();

    return (
        <main className="legal-page">
            <Seo canonicalPath={location.pathname} description="The requested WiseCursor page could not be found." noIndex title="Page not found" />
            <div className="container legal-page__content">
                <p className="legal-page__eyebrow">404</p>
                <h1>Page not found</h1>
                <p>The page may have moved or the address may be incorrect.</p>
                <p><Link to="/">Return to WiseCursor</Link></p>
            </div>
        </main>
    )
  };
  
  export default NoPage;
